function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".emailSenta{fill:url(#a);}.emailSentb{fill:url(#b);}.emailSentc{fill:#1457ef;}.emailSentd{opacity:0.87;fill:url(#c);}.emailSente,.emailSentg{fill:#fff;}.emailSente{opacity:0.86;}.emailSentf{opacity:0.63;}.emailSenth{fill:url(#d);}.emailSenti{clip-path:url(#f);}.emailSentj{clip-path:url(#h);}.emailSentk{fill:#001ba0;}.emailSentl{fill:#2d5ac9;}.emailSentl,.emailSentm,.emailSentn{fill-rule:evenodd;}.emailSentm{fill:#5587e0;}.emailSentn{fill:#98bff9;}.emailSento{fill:#3e50ee;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.532,
  y1: -0.457,
  x2: 0.429,
  y2: 1.84,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#b0d8ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2965f9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 0.553,
  y1: -0.426,
  x2: 0.448,
  y2: 1.882,
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 0.495,
  y1: 1.123,
  x2: 0.514,
  y2: -1.225,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fda118"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 0.533,
  y1: -1.859,
  x2: 0.48,
  y2: 2.67,
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSenta",
  d: "M1424.736,1588.894l-72.359,52.044a5.364,5.364,0,0,1-2.666-4.733v-96.662a5.64,5.64,0,0,1,.724-2.788Z",
  transform: "translate(-1349.711 -1536.755)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentb",
  d: "M2165.114,1535.525v96.662a5.541,5.541,0,0,1-1.4,3.726l-72.731-51.038,73.122-52.591A5.607,5.607,0,0,1,2165.114,1535.525Z",
  transform: "translate(-2090.981 -1532.284)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1107.153 -533.399)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1107.153 533.399)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.55 32.568)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentc",
  d: "M1504.291,1514.061l-73.122,52.591-74.3-52.139a4.751,4.751,0,0,1,4.108-2.5h139.493A4.7,4.7,0,0,1,1504.291,1514.061Z",
  transform: "translate(-1356.144 -1445.53)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.663)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "emailSentd",
  width: 112.169,
  height: 145.552,
  rx: 10
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSente",
  width: 43.406,
  height: 58.037,
  rx: 10,
  transform: "translate(7.033 7.429)"
}), /*#__PURE__*/React.createElement("g", {
  className: "emailSentf",
  transform: "translate(55.566 7.429)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentg",
  d: "M1.588,0H48.77a1.588,1.588,0,0,1,1.588,1.588v0A1.588,1.588,0,0,1,48.77,3.175H1.588A1.588,1.588,0,0,1,0,1.588v0A1.588,1.588,0,0,1,1.588,0Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 7.762)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 15.523)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 23.285)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 31.047)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 38.809)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 46.57)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "emailSentg",
  width: 50.358,
  height: 3.175,
  rx: 1.588,
  transform: "translate(0 54.332)"
})), /*#__PURE__*/React.createElement("path", {
  className: "emailSente",
  d: "M1693.314,1590.141a4.261,4.261,0,0,1,4.055,4.441v15.964a4.261,4.261,0,0,1-4.055,4.441H1603.07a4.261,4.261,0,0,1-4.055-4.441v-15.964a4.261,4.261,0,0,1,4.055-4.441",
  transform: "translate(-1591.445 -1515.754)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 68.531)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSenth",
  d: "M1521.144,2102.937a4.616,4.616,0,0,1-3.431,1.566H1378.22a4.477,4.477,0,0,1-2.166-.56l72.359-52.044Z",
  transform: "translate(-1373.388 -1999.308)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.453)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSenta",
  d: "M1424.736,1588.894l-72.359,52.044a5.364,5.364,0,0,1-2.666-4.733v-96.662a5.64,5.64,0,0,1,.724-2.788Z",
  transform: "translate(-1349.711 -1536.755)"
}), /*#__PURE__*/React.createElement("g", {
  className: "emailSenti"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentg",
  d: "M1350.654,2070.752l76.387-54.989,3.9,4.155-78.168,52.983Z",
  transform: "translate(-1350.558 -1967.282)"
}), /*#__PURE__*/React.createElement("path", {
  className: "emailSentg",
  d: "M1337.658,1506.048l77.484,54.89,1.006-5.615-77.27-53.333Z",
  transform: "translate(-1338.878 -1505.51)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(75.025)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentb",
  d: "M2165.114,1535.525v96.662a5.541,5.541,0,0,1-1.4,3.726l-72.731-51.038,73.122-52.591A5.607,5.607,0,0,1,2165.114,1535.525Z",
  transform: "translate(-2090.981 -1532.284)"
}), /*#__PURE__*/React.createElement("g", {
  className: "emailSentj"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentg",
  d: "M2138.629,2081.656l-76.953-54.415-3.9,4.155,78.168,52.983Z",
  transform: "translate(-2061.136 -1977.145)"
}), /*#__PURE__*/React.createElement("path", {
  className: "emailSentg",
  d: "M2169.568,1485.651l-77.581,55.537-1.006-5.615,77.27-53.333Z",
  transform: "translate(-2090.981 -1487.306)"
}))))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 8.806)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.831 117.459)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentk",
  d: "M1333.24,1782.019a.506.506,0,0,1-.015-1.012c.737-.022,1.172-.065,1.176-.066a.506.506,0,0,1,.1,1.007c-.019,0-.471.047-1.248.07Z",
  transform: "translate(-1332.735 -1780.939)"
})), /*#__PURE__*/React.createElement("path", {
  className: "emailSentk",
  d: "M1128.079,738.923h-.024c-.818-.038-1.641-.106-2.444-.2a.506.506,0,0,1,.12-1.005c.779.093,1.576.159,2.37.2a.506.506,0,0,1-.023,1.012Zm-4.792-.579a.508.508,0,0,1-.1-.01c-.818-.164-1.621-.361-2.387-.586a.506.506,0,1,1,.285-.971c.738.217,1.512.407,2.3.565a.506.506,0,0,1-.1,1Zm-4.624-1.369a.5.5,0,0,1-.191-.038,21.3,21.3,0,0,1-2.231-1.061.506.506,0,0,1,.488-.887,20.319,20.319,0,0,0,2.125,1.01.506.506,0,0,1-.191.975Zm-4.21-2.333a.5.5,0,0,1-.3-.1,17.094,17.094,0,0,1-1.887-1.614.506.506,0,0,1,.713-.718,16.055,16.055,0,0,0,1.775,1.518.506.506,0,0,1-.3.913Zm-3.405-3.388a.505.505,0,0,1-.408-.205,16.544,16.544,0,0,1-1.32-2.1.506.506,0,1,1,.9-.472,15.494,15.494,0,0,0,1.239,1.975.506.506,0,0,1-.406.807Zm-2.248-4.244a.506.506,0,0,1-.476-.335,19.9,19.9,0,0,1-.685-2.374.506.506,0,1,1,.988-.221,18.936,18.936,0,0,0,.65,2.253.507.507,0,0,1-.476.677Zm-1.055-4.694a.506.506,0,0,1-.5-.456c-.059-.6-.089-1.2-.089-1.787,0-.23,0-.463.014-.692a.506.506,0,0,1,1.011.04c-.009.215-.013.434-.013.651,0,.555.028,1.123.084,1.688a.506.506,0,0,1-.454.553Zm.2-4.8a.507.507,0,0,1-.5-.6,16.974,16.974,0,0,1,.637-2.4.506.506,0,0,1,.957.331,15.928,15.928,0,0,0-.6,2.253A.506.506,0,0,1,1107.943,717.518Zm1.561-4.537a.506.506,0,0,1-.45-.736,19.92,19.92,0,0,1,1.26-2.125.506.506,0,1,1,.838.568,18.913,18.913,0,0,0-1.2,2.017A.506.506,0,0,1,1109.5,712.981Zm2.688-3.986a.506.506,0,0,1-.385-.834c.515-.605,1.079-1.209,1.678-1.794a.506.506,0,0,1,.707.724c-.577.563-1.12,1.144-1.614,1.725A.5.5,0,0,1,1112.193,708.995Zm3.438-3.373a.506.506,0,0,1-.324-.895c.608-.506,1.258-1.011,1.932-1.5a.506.506,0,1,1,.594.819c-.656.476-1.288.966-1.878,1.458A.5.5,0,0,1,1115.631,705.622Zm3.9-2.837a.506.506,0,0,1-.273-.932c.665-.426,1.367-.851,2.085-1.262a.506.506,0,1,1,.5.878c-.7.4-1.391.819-2.042,1.236A.5.5,0,0,1,1119.53,702.785Zm4.184-2.4a.506.506,0,0,1-.233-.956c.7-.362,1.437-.724,2.183-1.073a.506.506,0,1,1,.43.917c-.734.344-1.457.7-2.148,1.056A.5.5,0,0,1,1123.713,700.384Zm4.368-2.051a.506.506,0,0,1-.2-.971c.728-.312,1.484-.621,2.247-.921a.506.506,0,1,1,.37.942c-.754.3-1.5.6-2.219.909A.5.5,0,0,1,1128.081,698.333Zm4.491-1.765a.506.506,0,0,1-.172-.982c.746-.269,1.517-.537,2.292-.8a.506.506,0,1,1,.32.96c-.767.256-1.53.52-2.268.787A.506.506,0,0,1,1132.572,696.568Zm4.578-1.527a.506.506,0,0,1-.149-.99c.759-.234,1.541-.465,2.324-.689a.506.506,0,1,1,.278.973c-.777.222-1.552.451-2.3.683A.506.506,0,0,1,1137.15,695.04Zm4.641-1.325a.506.506,0,0,1-.129-1c.769-.2,1.559-.4,2.348-.6a.506.506,0,1,1,.241.983c-.783.192-1.567.391-2.33.593A.506.506,0,0,1,1141.791,693.715Zm4.688-1.15a.506.506,0,0,1-.112-1c.776-.177,1.572-.35,2.365-.518a.506.506,0,0,1,.209.99c-.788.166-1.579.339-2.35.514A.508.508,0,0,1,1146.479,692.565Zm4.723-1a.506.506,0,0,1-.1-1c.782-.152,1.582-.3,2.379-.446a.506.506,0,0,1,.179,1c-.792.143-1.588.292-2.365.443A.511.511,0,0,1,1151.2,691.57Zm4.749-.86a.506.506,0,0,1-.086-1l2.38-.413a.506.506,0,1,1,.173,1l-2.38.413A.5.5,0,0,1,1155.951,690.71Zm4.76-.826a.506.506,0,0,1-.086-1l2.379-.415a.506.506,0,1,1,.174,1l-2.38.415A.509.509,0,0,1,1160.711,689.883Zm4.759-.83a.506.506,0,0,1-.087-1l2.379-.416a.506.506,0,0,1,.175,1l-2.379.416A.512.512,0,0,1,1165.469,689.053Zm4.758-.833a.506.506,0,0,1-.087-1l2.378-.418a.506.506,0,1,1,.175,1l-2.379.418A.5.5,0,0,1,1170.227,688.22Zm4.757-.836a.506.506,0,0,1-.087-1l2.378-.419a.506.506,0,1,1,.176,1l-2.378.419A.522.522,0,0,1,1174.984,687.384Zm4.756-.839a.506.506,0,0,1-.088-1l2.378-.421a.506.506,0,1,1,.177,1l-2.378.421A.511.511,0,0,1,1179.74,686.544Zm4.755-.842a.506.506,0,0,1-.088-1l2.377-.423a.506.506,0,0,1,.177,1l-2.378.423A.515.515,0,0,1,1184.495,685.7Zm4.755-.846a.506.506,0,0,1-.088-1l2.377-.424a.506.506,0,1,1,.178,1l-2.377.424A.507.507,0,0,1,1189.249,684.856Zm4.746-.847a.506.506,0,0,1-.088-1l2.371-.425a.506.506,0,1,1,.179,1l-2.372.425A.5.5,0,0,1,1194,684.009Zm4.747-.851a.506.506,0,0,1-.089-1l2.377-.428a.506.506,0,0,1,.179,1l-2.378.428A.508.508,0,0,1,1198.742,683.157Zm4.758-.857a.506.506,0,0,1-.089-1l2.383-.431a.506.506,0,0,1,.18,1l-2.383.431A.5.5,0,0,1,1203.5,682.3Zm4.759-.861a.506.506,0,0,1-.09-1l2.375-.431a.506.506,0,1,1,.181,1l-2.376.432A.5.5,0,0,1,1208.259,681.44Zm4.751-.864a.506.506,0,0,1-.09-1l2.375-.434a.506.506,0,1,1,.182,1l-2.376.434A.5.5,0,0,1,1213.01,680.576Zm4.75-.869a.506.506,0,0,1-.091-1l2.375-.436a.506.506,0,1,1,.183,1l-2.375.436A.512.512,0,0,1,1217.76,679.707Zm4.75-.874a.506.506,0,0,1-.091-1l2.374-.439a.506.506,0,1,1,.184,1l-2.375.439A.507.507,0,0,1,1222.51,678.833Zm4.749-.88a.506.506,0,0,1-.092-1l2.374-.443a.506.506,0,1,1,.186.995l-2.374.443A.5.5,0,0,1,1227.258,677.953Zm4.748-.887a.506.506,0,0,1-.093-1l2.373-.447a.506.506,0,1,1,.188.995l-2.374.447A.5.5,0,0,1,1232.006,677.065Zm4.746-.9a.506.506,0,0,1-.094-1l2.372-.452a.506.506,0,1,1,.19.994l-2.373.452A.5.5,0,0,1,1236.752,676.169Zm4.745-.906a.506.506,0,0,1-.1-1l2.371-.458a.506.506,0,1,1,.193.994l-2.372.458A.513.513,0,0,1,1241.5,675.263Zm4.742-.92a.506.506,0,0,1-.1-1l2.369-.466a.506.506,0,1,1,.2.993l-2.371.467A.506.506,0,0,1,1246.239,674.343Zm4.74-.939a.506.506,0,0,1-.1-1q1.223-.245,2.367-.479a.506.506,0,0,1,.2.992q-1.144.233-2.37.479A.505.505,0,0,1,1250.978,673.4Zm4.735-.967a.506.506,0,0,1-.1-1q.842-.176,1.626-.342l.734-.156a.506.506,0,0,1,.211.99l-.734.156q-.785.167-1.63.343A.521.521,0,0,1,1255.713,672.437Zm4.722-1a.506.506,0,0,1-.106-1q1.175-.252,2.358-.511a.506.506,0,0,1,.216.989q-1.184.259-2.361.512A.5.5,0,0,1,1260.435,671.434Zm4.713-1.033a.506.506,0,0,1-.11-1c.81-.182,1.6-.362,2.348-.536a.506.506,0,1,1,.229.986c-.751.174-1.543.355-2.355.538A.5.5,0,0,1,1265.148,670.4Zm4.7-1.094a.506.506,0,0,1-.119-1c.8-.193,1.586-.388,2.339-.579a.506.506,0,1,1,.249.981c-.757.192-1.548.388-2.35.582A.513.513,0,0,1,1269.849,669.308Zm4.684-1.189a.506.506,0,0,1-.13-1c.79-.211,1.572-.427,2.324-.64a.506.506,0,1,1,.276.974c-.757.214-1.544.431-2.339.644A.506.506,0,0,1,1274.532,668.119Zm4.649-1.319a.506.506,0,0,1-.146-.99c.78-.236,1.552-.477,2.294-.717a.506.506,0,1,1,.311.963c-.748.242-1.527.485-2.313.723A.508.508,0,0,1,1279.181,666.8Zm4.592-1.488a.506.506,0,0,1-.167-.984c.768-.268,1.527-.543,2.257-.818a.506.506,0,0,1,.357.947c-.738.278-1.505.556-2.281.827A.508.508,0,0,1,1283.773,665.311Zm4.515-1.706a.506.506,0,0,1-.192-.974c.751-.308,1.492-.626,2.2-.945a.506.506,0,0,1,.414.923c-.72.323-1.471.646-2.233.958A.505.505,0,0,1,1288.288,663.605Zm4.4-1.98a.506.506,0,0,1-.225-.96c.727-.359,1.44-.73,2.122-1.1a.506.506,0,0,1,.486.888c-.694.38-1.421.758-2.159,1.123A.5.5,0,0,1,1292.689,661.626Zm4.229-2.32a.506.506,0,0,1-.264-.938c.69-.421,1.363-.857,2-1.3a.506.506,0,0,1,.573.834c-.654.449-1.343.895-2.048,1.325A.5.5,0,0,1,1296.919,659.306Zm3.971-2.734a.506.506,0,0,1-.312-.905c.634-.494,1.247-1.006,1.825-1.523a.506.506,0,1,1,.675.754c-.594.532-1.226,1.059-1.877,1.566A.5.5,0,0,1,1300.89,656.572Zm3.587-3.217a.506.506,0,0,1-.365-.857c.553-.575,1.083-1.172,1.573-1.774a.506.506,0,0,1,.785.64c-.508.623-1.056,1.241-1.629,1.836A.5.5,0,0,1,1304.476,653.355Zm3.04-3.737a.506.506,0,0,1-.418-.79c.443-.653.858-1.331,1.234-2.013a.506.506,0,0,1,.887.488c-.391.71-.823,1.414-1.283,2.093A.505.505,0,0,1,1307.516,649.619Zm2.321-4.216a.506.506,0,0,1-.464-.708l.05-.117a13.822,13.822,0,0,0,.707-2.082.506.506,0,0,1,.982.245,14.854,14.854,0,0,1-.757,2.234l-.054.124A.506.506,0,0,1,1309.837,645.4Zm1.133-4.662h-.021a.506.506,0,0,1-.485-.526c.006-.14.009-.282.009-.422a10.131,10.131,0,0,0-.172-1.86.506.506,0,0,1,.995-.186,11.156,11.156,0,0,1,.189,2.046c0,.154,0,.31-.01.463A.506.506,0,0,1,1310.97,640.741Zm-.875-4.692a.506.506,0,0,1-.465-.307,12.022,12.022,0,0,0-1.117-2.019.506.506,0,0,1,.836-.57,13.045,13.045,0,0,1,1.21,2.19.506.506,0,0,1-.465.706Zm-2.678-3.977a.505.505,0,0,1-.368-.159,18.789,18.789,0,0,0-1.717-1.6.506.506,0,1,1,.644-.781,19.762,19.762,0,0,1,1.81,1.685.506.506,0,0,1-.368.853Zm-3.7-3.076a.5.5,0,0,1-.281-.085c-.634-.423-1.315-.837-2.026-1.23a.506.506,0,0,1,.491-.885c.734.407,1.44.836,2.1,1.274a.506.506,0,0,1-.281.927Zm-4.212-2.346a.5.5,0,0,1-.214-.048c-.7-.326-1.435-.644-2.188-.943a.506.506,0,0,1,.374-.941c.772.307,1.526.632,2.243.967a.506.506,0,0,1-.214.965Zm-4.481-1.787a.505.505,0,0,1-.163-.027c-.737-.25-1.5-.491-2.281-.715a.506.506,0,1,1,.281-.972c.791.229,1.573.474,2.325.729a.506.506,0,0,1-.163.985Zm-4.634-1.344a.509.509,0,0,1-.121-.015c-.761-.187-1.547-.364-2.336-.526a.506.506,0,1,1,.2-.991c.8.165,1.6.345,2.373.535a.506.506,0,0,1-.12,1Zm-4.726-.976a.509.509,0,0,1-.085-.007c-.776-.132-1.573-.254-2.369-.363a.506.506,0,1,1,.137-1c.807.11,1.615.234,2.4.368a.506.506,0,0,1-.084,1.005Zm-26.444-.274a.506.506,0,0,1-.067-1.008c.8-.108,1.607-.207,2.407-.3a.506.506,0,0,1,.11,1.006c-.792.087-1.593.185-2.382.292A.5.5,0,0,1,1259.219,622.269Zm21.662-.383a.5.5,0,0,1-.054,0c-.786-.083-1.589-.156-2.389-.217a.506.506,0,1,1,.077-1.009c.809.062,1.623.136,2.418.22a.506.506,0,0,1-.053,1.009Zm-16.867-.143a.506.506,0,0,1-.042-1.01c.8-.067,1.617-.125,2.42-.172a.506.506,0,0,1,.059,1.01c-.794.046-1.6.1-2.394.17Zm12.054-.225h-.025c-.791-.038-1.6-.066-2.4-.082a.506.506,0,0,1,.021-1.012c.809.017,1.625.045,2.426.083a.506.506,0,0,1-.024,1.012Zm-7.237-.054a.506.506,0,0,1-.016-1.012c.807-.026,1.623-.042,2.425-.046h0a.506.506,0,0,1,0,1.012c-.794,0-1.6.02-2.4.046Z",
  transform: "translate(-1107.153 -620.406)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(148.016 1.199)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentk",
  d: "M2570.1,633.471a.506.506,0,0,1-.087-1c.4-.07.8-.138,1.2-.2a.506.506,0,0,1,.161,1c-.4.064-.8.132-1.191.2A.508.508,0,0,1,2570.1,633.471Z",
  transform: "translate(-2569.595 -632.257)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(119.079 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentl",
  d: "M2426.876,620.362l2.391,1.94-8.257-.261-8.678-1.679,3.646-3.763Z",
  transform: "translate(-2399.313 -608.178)"
}), /*#__PURE__*/React.createElement("path", {
  className: "emailSentm",
  d: "M2308.433,587.55l.666,1.1,4.547,7.546-4.979-1.862-1.1,1.019-16.156-2.009-7.723-1.839,14.2-3.757Z",
  transform: "translate(-2283.692 -582.069)"
}), /*#__PURE__*/React.createElement("path", {
  className: "emailSentn",
  d: "M2283.692,542.833l26.5-9.412a.359.359,0,0,1,.467.426l-1.56,6.131Z",
  transform: "translate(-2283.692 -533.399)"
}), /*#__PURE__*/React.createElement("path", {
  className: "emailSentn",
  d: "M2308.668,629.435l-24.976-2.829,24.177,10.958a.358.358,0,0,0,.506-.313Z",
  transform: "translate(-2283.692 -617.172)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(82.985 135.345)"
}, /*#__PURE__*/React.createElement("path", {
  className: "emailSentg",
  d: "M1965.975,2150.964l-2.425,32.76,15.532-9.376,16.808,10.25-5.951-35.986Z",
  transform: "translate(-1959.857 -2120.479)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "emailSentg",
  cx: 18.016,
  cy: 18.016,
  r: 18.016
}), /*#__PURE__*/React.createElement("circle", {
  className: "emailSento",
  cx: 13.195,
  cy: 13.195,
  r: 13.195,
  transform: "translate(4.822 4.822)"
}))));

var SvgEmailSent = function SvgEmailSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204.332,
    height: 206.293,
    viewBox: "0 0 204.332 206.293",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmailSent.91071234.svg";
export { ForwardRef as ReactComponent };